(function() {
	const initTabs = () => {
		const tabsNavItems = document.querySelectorAll('.c-tabNav__item');
		const tabContentElements = document.querySelectorAll('.c-tabContent');

		const handleTabNavItemClick = function(e) {
			e.preventDefault();

			const targetId = e.target.getAttribute('href').substr(1);
			const targetElement = document.getElementById(targetId);

			// Set/Remove active class on nav item
			Array.from(tabsNavItems).forEach(navItem => navItem.classList.remove('is-active'));
			e.target.classList.add('is-active');

			// Set/Remove active class on tab content
			if (tabContentElements && tabContentElements.length) {
				Array.from(tabContentElements).forEach(tabContentElement => tabContentElement.classList.remove('is-active'));
				targetElement.classList.add('is-active');
			}
		};

		if (tabsNavItems && tabsNavItems.length) {
			Array.from(tabsNavItems).forEach(navItem => navItem.addEventListener('click', handleTabNavItemClick));
		}
	};

	document.addEventListener('DOMContentLoaded', initTabs);
})();
